import React from 'react'
import theme from '../config/theme'

interface CheckboxProps {
  id?: string
  name?: string
  checked?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  label?: string
  className?: string
  centered?: boolean
}

const Checkbox: React.FC<CheckboxProps> = ({
  id,
  name,
  checked = false,
  onChange,
  disabled = false,
  label,
  className = '',
  centered = false
}) => {
  const containerClasses = `flex items-center ${className}`

  return (
    <div className={containerClasses}>
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        className="h-4 w-4 rounded focus:ring-2 cursor-pointer"
        style={{
          accentColor: theme.color.gray500,
          borderColor: theme.color.light500,
          color: theme.brandColor.red
        }}
        disabled={disabled}
      />
      {label && (
        <label
          htmlFor={id}
          className="ml-2 block text-sm cursor-pointer"
          style={{ color: theme.color.gray400 }}
        >
          {label}
        </label>
      )}
    </div>
  )
}

export default Checkbox

